import { render, staticRenderFns } from "./v-alert-local.vue?vue&type=template&id=b2cbe85c&scoped=true&"
import script from "./v-alert-local.vue?vue&type=script&lang=js&"
export * from "./v-alert-local.vue?vue&type=script&lang=js&"
import style0 from "./v-alert-local.vue?vue&type=style&index=0&id=b2cbe85c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cbe85c",
  null
  
)

export default component.exports